// extracted by mini-css-extract-plugin
export default {"struck":"BQ9AFf","positivePrice":"VzSoAt","infoIcon":"jG2DfJ"};